webpackJsonp([24564736899305],{

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HookTutorial = __webpack_require__(50);
	
	var _HookTutorial2 = _interopRequireDefault(_HookTutorial);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _HookTutorial2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 3: Specify Dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to specify our hook\'s dependencies, so we\'ll have access to the data we need when the hook loads.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can view the finished code for this step by checking out the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'step-3'
	        ),
	        ' branch.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Hook Dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While some hooks are completely stand-alone, most hooks don\'t operate that way, and expect certain data (generated by other hooks) to be available by the time that hook loads.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'An example of a stand-alone hook is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-models'
	      ),
	      ', which loads the model config files provided in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/models'
	      ),
	      ' and converts them all to instances of a Model from the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-models'
	      ),
	      ' package. Whether this is the first hook that gets loaded or the last doesn\'t matter.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'actions'
	      ),
	      ' hook on the other hands expects ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.models'
	      ),
	      ' to exist before it loads, because it needs those Model classes in order to build the action creators. In other words, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'actions'
	      ),
	      ' hook depends on the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'models'
	      ),
	      ' hook.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bindActions'
	      ),
	      ' hook is another hook with dependencies, as it\'s responsibility is to bind every action to the',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dispatch'
	      ),
	      ' method of the Redux store. So the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bindActions'
	      ),
	      ' hook depends on both the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'actions'
	      ),
	      ' hook and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'redux'
	      ),
	      'hook, because it\'s need the actions to be created first, as well as the Redux store, so that it can perform that binding.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Specify Dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Our hook is going to be responsible for creating a container that will invoke an action on a given interval. In order to do that, we need to make sure the actions are all built (and bound to the Redux store) before we create a polling wrapper around them. This means our hook has a dependency on the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bindActions'
	      ),
	      ' hook.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To specify this dependency, add a reference to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bindActions'
	      ),
	      ' hook in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dependencies'
	      ),
	      ' array like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      ...\n        dependencies: [\'bindActions\'],\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That\'s it! With the array populated, Lore will figure out which order to load the hooks in based on their dependency chains, and we are guaranteed that our hook will load only ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'after'
	      ),
	      ' the actions exist and are bound to the Redux store.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-4/' },
	        'make our hook configurable'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-tutorial-step-3-js-9b9ad531f4ae796eefd0.js